import { Box, Typography } from "@mui/material";
import { escapeForRegEx } from "@tiptap/core";
import clsx from "clsx";

interface IHighlightedTextProps {
	text: string;
	highlight: string;
}

export const HighlightedtText = ({ text, highlight }: Readonly<IHighlightedTextProps>) => {
	const escapedHighlight = escapeForRegEx(highlight);
	const parts = !escapedHighlight ? [text] : text?.split(new RegExp(`(${escapedHighlight})`, "gi")) || null;

	return (
		<Box component="span" className="overflow-hidden overflow-ellipsis">
			{parts?.map((part, index) => {
				const compoundedKey = `${part}-${index}`;
				return (
					<Typography
						key={compoundedKey}
						component="span"
						className={clsx("!font-sans p-0 m-0 text-default !text-[14.5px]", {
							"font-semibold": part.toLowerCase() === highlight.toLowerCase(),
						})}
					>
						{part}
					</Typography>
				);
			})}
		</Box>
	);
};
